export default "__VITE_ASSET__D4K5OCwu__"